import * as React from "react"
const Right = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width={"100%"}
    height={"100%"}
    x={0}
    y={0}
    style={{
      maxHeight: 500,
    }}
    viewBox="7.797 4.495 105.56 51.245"
    {...props}
  >
    <style>
      {
        `.st1{display:inline;fill:none;stroke:#000;stroke-width:.6;stroke-miterlimit:10}.st2{fill:none;stroke-width:.25}.st2,.st3,.st4{stroke:${props.color};stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st3{fill:none;stroke-width:.4}.st4{stroke-width:.6}.st4,.st5{fill:none}.st5,.st6,.st7,.st9{stroke:${props.color};stroke-miterlimit:10}.st6{fill:none;stroke-width:.5;stroke-linecap:round;stroke-linejoin:round}.st7,.st9{fill:${props.color}}.st9{fill:none;stroke-width:.6}`
      }
    </style>
    <g id="Layer_6">
      <path
        d="m91.6 28.2.2.3c1.7-.9 3.8-1.7 6.2-1.9-2.3-.1-4.4.6-6.4 1.6zM84.7 35.8c1.1-2.1 2.7-4.5 5.6-6.5l-.2-.2c-2.5 1.7-4.3 4-5.4 6.7z"
        className="st2"
      />
      <path
        d="m88.6 27 .5.8.6.9h.2l1.4-.9.3-.2-.6-1-.5-.8-.3.2-1.3.8z"
        className="st3"
      />
      <path d="m91.6 28.2.2.3" className="st2" />
      <path
        d="m84.9 20.8 1 1.5.3-.1 1.3-.8.3-.2-.9-1.6-.2.2-1.4.9zM84.4 21.4l.7 1.3c-2.2 4.1 0 8.8 0 8.8"
        className="st3"
      />
      <path d="M79.3 13c.2-.1.5-.1.5-.1" className="st2" />
      <path
        d="M77.8 6.2c.4.7.3 1.9.3 1.9.4-.1.7-.1.9 0s.3.4.4.8c.7.1 1.2.3 1.7.5.9.3 1.6.7 1.6.7-.5-.7-1-1.3-1.5-1.9-1.6-1.5-3.4-2.1-3.4-2z"
        className="st3"
      />
      <path
        d="M48.7 47.3c.2.6.7 1.6 1.7 1.7l5.8.2c.8 0 2-.9 2-.9s3.7.3 4 .2 1.3-.3 1.9-.3 1.4.5 2.5.5 3.7-1.1 4.1-1.1 2 .1 2 .1l3.3-3.9h.6c.6 0 .8-.3.8-.6v-.9c0-.7-.6-.7-1.1-.7s-.7-.3-.7-.3 1.5-5.2 2.4-7.3c.5-2.6 1-4.6 1.8-6.1v-.1c.1-2.4 1.1-5.1 1.3-5.1.1 0 .5-.3 1-.5.9-.5 2.2-1 2.2-1L83.2 19l-.7-.9-1.5-3h0l-1.7-1.9c-.6.3-.5 2.2-.6 2.2l.1.2.6 1 1.3 2.6-.9.5-3.6 12.9s-.1.1-.2.4c0 .8-1.1 3.7-1.1 3.7s0 .9-.1 2.2c0 .4-.3.7-.7.9-.3 1.5-1.8 7.7-8.4 7.7-5.9-.4-10.5-.5-12.4-.5h-.1c-.5.1-1.2.1-1.9.2-.5.1-1.5.1-2.6.1z"
        className="st4"
      />
      <path
        d="m75.1 7.3.8 1.2-.3.3.3.3c.4-.4 1.2-.7 1.9-.9.1 0 .2-.1.3-.1 0 0 .1-1.2-.3-1.9-.1-.2-.2-.3-.4-.4 0-.1-.1-.1-.2-.1L75 5.6c.3.7.3 1.6.1 1.7zM42.7 41.3c-.8.3-1 2.1-2.3 2.1"
        className="st3"
      />
      <path
        d="M23.7 40.9s.1 0 0 0h1.1l8 .2 1.3.1 2 .1h.1s5.5.1 6 .1c.6-.1 1.3-.2 2.3-.8.2-.1.7-.5 1.5-.9h-.4l-4.5-.4-4.7-.3-1.9-.1-1.3-.1-2.9-.1h-.8l-5.4-.3-.1 1-.3 1.5zm1.6-1.1c0-.5.4-.8.8-.8.5 0 .8.4.8.8 0 .5-.4.8-.8.8s-.9-.3-.8-.8z"
        className="st5"
      />
      <path
        d="M23.7 40.9s.1 0 0 0h1.1l8 .2 1.3.1 2 .1h.1s5.5.1 6 .1c.6-.1 1.3-.2 2.3-.8.2-.1.7-.5 1.5-.9h-.4l-4.5-.4-4.7-.3-1.9-.1-1.3-.1-2.9-.1h-.8l-5.4-.3-.1 1-.3 1.5zm1.6-1.1c0-.5.4-.8.8-.8.5 0 .8.4.8.8 0 .5-.4.8-.8.8s-.9-.3-.8-.8z"
        className="st3"
      />
      <circle cx={26.1} cy={39.8} r={0.8} className="st6" />
      <path
        d="M21.6 26.8s10.7.2 13.6.3h.6c.4 0 1 .2 1.7.7.5.3 1 .6 1.5 1.2l2.6.1c-.4-.9-.6-1.6-.8-2.2-1.6-.3-2.8-.9-3.7-1.6h-1.3l-5 .1h-9.5c-.2.1.4 1 .3 1.4zm16.7 1c0-.5.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1-.7 0-1-.4-1-1z"
        className="st5"
      />
      <path
        d="M38.8 28.9c.3.3.5.6.8.9.9 1.3 1.8 6.7 1.6 9.4l1.6.2s.3-5.9-.5-8.1c-.4-.9-.6-1.6-.8-2.2 0-.1-2.7-.2-2.7-.2z"
        className="st5"
      />
      <path
        d="M38.8 28.9c.3.3.5.6.8.9.9 1.3 1.8 6.6 1.6 9.3l1.6.1s.3-5.8-.5-8c-.4-.9-.6-1.6-.8-2.2l-2.7-.1z"
        className="st4"
      />
      <path
        d="M38.3 27.8c0 .5.4 1 1 1s1-.4 1-1c0-.5-.4-1-1-1-.6.1-1 .5-1 1z"
        className="st5"
      />
      <path
        d="M38.3 27.8c0 .5.4 1 1 1s1-.4 1-1c0-.5-.4-1-1-1-.6.1-1 .5-1 1z"
        className="st2"
      />
      <path
        d="m40.4 41.4-2.5.1-1.6-.1-9.6-.3-1.3-.1-3.2-.1h-.1l-1.3.1h-.3l-2.8.1h-.5c-.9.2-.8.9-.8 1.5v.5c.1.5.6.6 1.2.7h1.6c.1 0 5.2.2 5.2.2 3.3 0 6.9.1 9.6.1h.4c.6 0 1.2.1 1.6.1h1.2c.5 0 1.3-.1 1.9-.3.1 0 .4-.1.4-.1.7-.2 1-.4 1-.4"
        className="st6"
      />
      <path
        d="M69.9 7.8c.4-.1 1.2-.1 2-.3.5-.2 2.7-.1 3.1-.4.2-.1.5-1.4-.2-1.5 0 0-2.6-.1-3 0-.6.2-1.3.4-2 .4-.6 0-.7 1.9.1 1.8z"
        className="st3"
      />
      <path
        d="m97 37.2-.5-.9-.6-1-1.6-2.7-.3-.5M92.5 33l.2.3.8 1.4.7 1.2 1.1 2v.1"
        className="st7"
      />
      <path
        d="m89.9 28.7.2.4.2.3 1.6 2.8 2.2 3.6 1.1 2 .7 1.1.7 1.1.7 1c.2.3 1.6-.5 1.4-.8l-1.8-2.9-.7-1.1-.6-1-2.3-3.7-1.7-2.8-.2-.3-.3-.4-1.2.7z"
        className="st3"
      />
      <path
        d="m39.6 27.8-.8 1.2.4.4-10.1 8.4c-.3.3-.9-.3-1.2-.5l-.3-.3c-.2-.3-.2-.8.2-1l10-8 .6.3.6-.7.6.2z"
        className="st5"
      />
      <path
        d="m39.6 27.8-.8 1.2.4.4-10.1 8.4c-.3.3-.9-.3-1.2-.5l-.3-.3c-.2-.3-.2-.8.2-1l10-8 .6.3.6-.7.6.2z"
        className="st3"
      />
      <path
        d="m81.3 13.9 2.2 3.6.6.9.9 1.5c.2.4.7.5 1.1.2.3-.2.4-.7.2-1l-.8-1.5-2.2-3.6-.9-.1-2.7-1 1.6 1z"
        className="st5"
      />
      <path
        d="m81.3 13.9 2.2 3.6.6.9.9 1.5c.2.4.7.5 1.1.2h0c.3-.2.4-.7.2-1l-.8-1.5-2.2-3.6-.9-.1-2.6-.9 1.5.9z"
        className="st3"
      />
      <path
        d="m86.5 22.8 2 3.3c.2.4.7.5 1.1.2h.1c.3-.2.4-.7.2-1l-2-3.3c-.2-.4-.7-.5-1.1-.2h-.1c-.2.2-.4.7-.2 1z"
        className="st5"
      />
      <path
        d="m86.5 22.8 2 3.3c.2.4.7.5 1.1.2h.1c.3-.2.4-.7.2-1l-2-3.3c-.2-.4-.7-.5-1.1-.2l-.1.1c-.2.2-.4.6-.2.9zM91.6 27.6l-.2.2.3.4c1.9-1 4.1-1.5 6.4-1.6.9-.1 1.8-.1 2.8-.2 0 0 1-.4 2.4-1.2 0 0-6-2-12.1 1.4l.4 1zM81.6 40.6s.8-.2 1.5-1c0 0 .4-1.7 1.5-3.7 1.1-2.8 3-5.2 5.5-6.8l-.2-.4-.3.2-.5-1c-.5.4-1.1.9-1.7 1.3-.9.9-1.7 1.7-2.3 2.6-2.9 3.9-3.4 7.3-3.5 8.8z"
        className="st3"
      />
      <path d="M40.6 43.6c-.1 2.1 3.5 3.6 8 3.8" className="st4" />
      <path
        d="M36.9 28.8c0 .8.4 1.5 1.1 1.5M35.3 30.1c0 .7.6 1.3 1.4 1.4M29 35.2c0 .9.4 1.6 1.2 1.7M30.6 34c0 .8.5 1.3 1.3 1.4M32.3 32.5c0 .8.5 1.5 1.3 1.6M34 31.1c0 .8.4 1.5 1.2 1.5"
        className="st3"
      />
      <path
        d="m28.1 37.6-1.1.8M27.7 37.2l-1.6 1.2M35.6 25.3C26.3 19.5 16.7 23 13 32"
        className="st6"
      />
      <path d="M37 25.2c-2.8-2.1-6.8-3.7-11.6-4.1" className="st4" />
      <path
        d="M25.3 21.1c-6.8.6-12.3 5.8-13.4 10.9M11.9 32c0 .1.6 0 1.1 0M7.8 27.6c0 1 3.2 4.3 4.1 4.4"
        className="st6"
      />
      <path d="M83.9 15c.1-2.8-.5-5-1.4-5" className="st3" />
    </g>
    <path
      d="m95.8 35.3-1.4-3.4"
      style={{
        fill: "none",
        stroke: `${props.color}`,
        strokeWidth: 0.4,
        strokeMiterlimit: 10,
      }}
    />
    <path
      d="M91.6 28.7c2.1-1.1 4.5-1.7 7.1-1.6 7.5.3 13.3 6.7 13 14.2s-6.7 13.3-14.2 13-13.3-6.7-13-14.2c.2-4.4 2.4-8.2 5.7-10.5"
      className="st9"
    />
    <path
      d="M93.9 32.1c1.4-.7 3-1 4.6-1 5.3.2 9.4 4.7 9.2 10-.2 5.3-4.7 9.4-10 9.2s-9.4-4.7-9.2-10c.1-3.1 1.7-5.8 4-7.4"
      className="st9"
    />
    <path
      d="M97 37.2c.3-.1.6-.1.9-.1 1.8.1 3.2 1.6 3.1 3.3-.1 1.8-1.6 3.2-3.3 3.1-1.8-.1-3.2-1.6-3.1-3.3 0-.8.3-1.5.8-2M96.7 43.4l-2 6.4M100.4 31.5 98.7 37M100.8 41.7l6.4 2.2M89 37.5l5.6 2M94.7 41.5l-5.8 2M107.2 37.2l-6.3 2.2M101.4 49.8l-2.6-6.5M24.9 36.8l-2.1-5.3"
      className="st9"
    />
    <path
      d="M40.3 27.9c0-.6-.4-1-1-1s-1 .5-1 1c0 .3.1.5.2.7.2.2.4.3.7.3.6 0 1.1-.5 1.1-1z"
      className="st5"
    />
    <path
      d="M29.6 27c2.3 0 4.5.1 5.6.1h.6c.4 0 1 .2 1.7.7.3.2.7.5 1 .8-.2-.2-.3-.4-.2-.7 0-.5.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1-.3 0-.5-.1-.7-.3.1.1.3.2.4.4l2.6.1c-.4-.9-.6-1.6-.8-2.2-1.6-.3-2.8-.9-3.7-1.6h-1.3l-5 .1h-9.5c-.1.1.6 1 .4 1.4 0 0 1 0 2.5.1M38.6 28.5c-.1 0-.1 0 0 0-.1 0-.1 0 0 0z"
      className="st4"
    />
    <path
      d="M40.1 39.2c-.2-2.9-1.4-5.6-3.2-7.7M35.4 29.9c-1.6-1.4-3.6-2.4-5.8-2.9-2 0-4-.1-5.5-.1C18 28 13.2 33.2 13 39.6c-.3 7.5 5.5 13.8 13 14.2 6.5.3 12.1-4.1 13.7-10.1"
      className="st9"
    />
    <path
      d="M16.9 41.3c-.1-.6 0-.7 0-1.3.2-5.3 4.7-9.4 10-9.2 1.9.1 3.7.7 5.2 1.8M35.4 44c-1.5 3.6-5.1 6.1-9.3 6-4-.2-7.3-2.7-8.6-6.2M33.7 34c1.2 1.3 2 3 2.3 4.9"
      className="st9"
    />
    <path
      d="M23.2 41c-.2-.4-.2-.7-.2-1.2.1-1.8 1.6-3.2 3.3-3.1 1.3.1 2.3.8 2.8 2M24.8 44.1l-1.7 5.3M28.9 31.1l-1.8 5.5M17.5 37.1l5.5 2M35.7 36.8l-6.3 1.8M29.9 49.4l-2.1-5.3"
      className="st9"
    />
    <circle cx={97.6} cy={40.2} r={0.1} className="st9" />
  </svg>
)
export default Right
